export const DragItemType = {
	DEVICE: 'DEVICE',
	CATEGORY: 'CATEGORY',
	ZONE: 'ZONE',
	ACTION_REMOVE: 'ACTION_REMOVE',
	ACTION_EDIT: 'ACTION_EDIT',
	ACTION_PIN: 'ACTION_PIN'
};